{
  "0629f48c230e746d": "Dar Retroalimentación",
  "10d20e340181a52f": "Selecciona todas las que correspondan",
  "11de3b88286c6167": "¿Qué cualidades podrían mejorar?",
  "12684ec2f0c1ea65": "Revisar Profesionales",
  "1509f561f2416598": "Guardar",
  "155f816c0407310c": "Enviar",
  "2875c4ffca926cfb": "Este profesional y otros lugares de trabajo",
  "2b6c74d8b1f2fd14": "Comparte por qué estás respaldando a este profesional",
  "32352fe744363d05": "Revisión de Habilidades",
  "36ba03a5676c2c15": "Agregar una advertencia para {{skill}} (actualmente marcado)",
  "410fb8b9a6a0b173": "¿Quién puede ver esta retroalimentación?",
  "47848513d9d5a830": "Aprobar {{skill}}",
  "4949b7599fc3e7be": "Ver aprobaciones de {{skill}}",
  "4d2eedf2048bec29": "No se pueden cargar los detalles de la recomendación.",
  "4ecd112119e2d8fa": "Anteriormente enviaste una advertencia a {{name}} por {{skill}}. Endorsar reemplazará esa advertencia.",
  "5948473cb85291e6": "Alternar endosos",
  "62e4c6f38c6d4e89": "Comparte por qué podrías bloquear a este profesional si no mejora",
  "6a1eda5ea53dc272": "Emitir advertencia",
  "6b86e3ccbcad816b": "Solo este profesional",
  "7c0156bbe423568e": "Cerrar endosos",
  "8275b5b6b1fa4e4d": "Próximo profesional",
  "94ea9b1d33a02975": "Mostrar menos",
  "951ccd104d51268a": "¿Qué competencias demostraron?",
  "9d716e7380171a24": "esta calidad",
  "a0c53db263f84bf3": "Ver detalles de la aprobación de {{skill}}",
  "a41bf8ada0416399": "Respaldar profesional",
  "a487060ccc02d84a": "Agregar una advertencia para {{skill}}",
  "aac77df347205252": "Retroalimentación",
  "aafe8bfcc0578c11": "Tu opinión va directamente al profesional. Hazle saber cómo lo está haciendo.",
  "b44001c59be87364": "Este profesional aún no tiene comentarios sobre esta calidad.",
  "d471b71ef926577f": "Aprobaciones",
  "d7a8974566f771f1": "Sin opciones",
  "d97ab656951b5218": "Esta retroalimentación irá directamente al profesional",
  "e4ff36b0fe818fd7": "Saltar, no estoy familiarizado",
  "e981ddae45d8f4ca": "Advertencia",
  "ec6eae07be163c87": "Aprobar {{skill}} (actualmente aprobado)",
  "efb33072f8e44823": "Profesional anterior",
  "f47e536b520c96a7": "Aprobación",
  "f5c9bd131486e793": "Mostrar más",
  "fb38cbfcfc5f7f62": "Anteriormente enviaste un endorsement de {{skill}} para {{name}}. Una advertencia reemplazará ese endorsement.",
  "fd5ca43ef5f13cca": "No se pudo enviar la retroalimentación. Por favor, inténtalo de nuevo."
}
